import { render } from "./TheMenu.vue?vue&type=template&id=0e3774ad&scoped=true"
import script from "./TheMenu.vue?vue&type=script&lang=js"
export * from "./TheMenu.vue?vue&type=script&lang=js"

import "./TheMenu.vue?vue&type=style&index=0&id=0e3774ad&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0e3774ad"

export default script